<template>
  <div class="default-modal welcome-bonus-modal">
    <div>
      <button type="button" class="default-modal__close" @click="$emit('close')">
        <IconComponent name="add" />
      </button>
    </div>
    <div class="default-modal__body welcome-bonus-modal__body">
      <div class="welcome-bonus-modal__icon">
        <IconComponent name="medal-star" />
      </div>
      <div class="welcome-bonus-modal__message">
        Вам начислено <strong>500 бонусов</strong> за регистрацию
      </div>
    </div>
    <div class="default-modal__footer welcome-bonus-modal__footer">
      <button type="button" class="btn btn--md btn--main" @click="$emit('close')">Отлично!</button>
    </div>
  </div>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "WelcomeBonusModal",
  components: { IconComponent },
};
</script>

<style lang="stylus">
.welcome-bonus-modal {
  width 100%
  max-width 453px
  text-align center

  &__body {
    display flex
    flex-direction column
    align-items center !important
		justify-content: center
    gap 20px
    padding 20px 0
  }

  &__icon {
    width 80px
    height 80px
    border-radius 50%
    background var(--main-color)
    display flex
    align-items center
    justify-content center

    .icon {
      width 40px
      height 40px
			color: var(--white)
    }
  }

  &__message {
    font-size 1.25em
    line-height 1.4
    color var(--body-color)

    strong {
      color var(--main-color)
    }
  }

  &__footer {
    .btn {
      width 100%
			max-width: 340px
      justify-content center
    }
  }
}
</style>
